import { AfterViewInit, ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { AuthFacade } from '../../store/state/auth/auth.facade';
import { RouterFacade } from '../../store';
import { BehaviorSubject, Subscription } from 'rxjs';
import { MatDrawer, MatDrawerMode } from '@angular/material/sidenav';
import { delay } from 'rxjs/operators';
import { AutoUnsubscribe, RoutePath } from '../../common';

@Component({
  selector: 'container-dashboard-layout',
  templateUrl: './dashboard-layout.component.html',
  styleUrls: ['./dashboard-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
@AutoUnsubscribe
export class DashboardLayoutComponent implements AfterViewInit {
  isMenuIconsAvailable = true;
  isBackdropAvailable = true;
  drawerMode: MatDrawerMode = 'over';
  selectedMenuItem$: BehaviorSubject<string> = new BehaviorSubject('');
  menuNavigation$: BehaviorSubject<string> = new BehaviorSubject<string>('');
  subscriptions: Subscription[] = [];
  sideNavDrawer$ = new BehaviorSubject<MatDrawer>(null);

  @ViewChild('drawer', { static: false }) sideNavDrawer: MatDrawer;

  constructor(public authFacade: AuthFacade, private routerFacade: RouterFacade) {}

  ngAfterViewInit(): void {
    this.checkStartPage();
  }

  updateSideNavDrawer(): void {
    this.sideNavDrawer$.next(this.sideNavDrawer);
  }

  private checkStartPage(): void {
    this.sideNavDrawer$.next(this.sideNavDrawer);
    this.subscriptions.push(
      this.routerFacade.currentUrl$.pipe(delay(0)).subscribe((url: string) => {
        url === `/${RoutePath.Dashboard}` ? this.setConfigForWelcomePage() : this.setDefaultState();
      }),
    );
  }

  private setConfigForWelcomePage(): void {
    this.isMenuIconsAvailable = false;
    this.isBackdropAvailable = false;
    this.drawerMode = 'side';
    if (this.sideNavDrawer) {
      this.sideNavDrawer.open();
      this.sideNavDrawer$.next(this.sideNavDrawer);
    }
  }

  private setDefaultState(): void {
    this.isMenuIconsAvailable = true;
    this.isBackdropAvailable = true;
    this.drawerMode = 'over';
  }
}
